<template>
  <div class="details_box">
    <div class="banner_box"></div>
    <div class="text_box">
      <div class="title_box">{{example.exampleTitle}}</div>
      <div class="more_box">
        <span>日期：{{example.createTime}}</span>
        <span style="padding-left: 50px;">浏览：{{example.browseCount}}</span>
      </div>
      <div class="text">

        <div class="ql-container">
          <div class="ql-editor"
               v-html="example.exampleContent"></div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import { getExample } from "@/api/presentation";
export default {
  components: {
    Footer,
  },
  data () {
    return {
      id: 0,
      exampleId: "",
      example: {},
    }
  },
  created () {
    this.exampleId = this.$route.query.exampleId;
    this.getExample();
  },
  methods: {
    getExample () {
      getExample(this.exampleId).then(response => {
        this.example = response.data;
        this.example.exampleContent = this.example.exampleContent.replace(/<img/g, '<img style="max-width:100%;"');
        console.log(this.example.exampleContent);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.details_box {
  color: #000;
  .banner_box {
    width: 10rem;
    height: 2.474rem;
    background-image: url("../../static/images/img/banner_box.png");
    background-size: 100% 100%;
  }
  .text_box {
    padding: 0 1.875rem;

    .title_box {
      text-align: center;
      font-size: 0.1563rem;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #000000;
      line-height: 0.1771rem;
      letter-spacing: 0.0104rem;
      margin-top: 0.2083rem;
    }
    .more_box {
      text-align: center;
      font-size: 0.1042rem;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 0.099rem;
      letter-spacing: 0.0104rem;
      margin-top: 0.1563rem;
    }
    .text {
      margin: 0.2604rem 0;
    }
    .bottom_box {
      display: flex;
      justify-content: space-between;
      font-size: 0.0833rem;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      margin-bottom: 0.2604rem;
      span {
        user-select: none;
        cursor: pointer;
      }
      .ISspan {
        color: #ff6100;
      }
    }
  }
}
</style>